'use strict';

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _Grid = require('react-bootstrap/lib/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _mozart_ui = require('@pgforsta/mozart_ui');

var _utilElement = require('utils/util-element');

var _utilElement2 = require('utils/util-element.js');

var _utilConstants = require('utils/util-constants.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SurveyHome = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    survey: state.survey.data.data,
    selectedLanguage: state.survey.selectedLanguage
  };
}, null), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SurveyHome, _Component);

  function SurveyHome(props) {
    (0, _classCallCheck3.default)(this, SurveyHome);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.styles = require('./SurveyHome.scss');
    _this.state = {
      height: window.innerHeight || document.documentElement.clientHeight,
      width: window.innerWidth || document.documentElement.clientWidth,
      device_type: (window.innerWidth || document.documentElement.clientWidth) < 992 ? 'mobile' : 'desktop'
    };
    (0, _utilElement2.fireGTMEvent)(_utilElement2.EVENT_PAGE_LOAD, _utilElement2.EVENT_PAGE_LOAD, 'Loading survey home page.');
    return _this;
  }

  SurveyHome.prototype.componentDidMount = function componentDidMount() {
    console.log(this.props.survey);
  };

  SurveyHome.prototype.startSurvey = function startSurvey() {
    var onStartSurvey = this.props.onStartSurvey;

    (0, _utilElement2.fireGTMEvent)(_utilElement2.EVENT_BTN_CLICK, _utilElement2.EVENT_BTN_CLICK, 'Start survey button clicked.');
    if (onStartSurvey) {
      this.props.onStartSurvey();
    }
  };

  SurveyHome.prototype.render = function render() {
    var survey = this.props.survey;

    var surveyStartTexts = (0, _utilElement.getSurveyStartTexts)();
    var defaultBackground = 'https://static.binaryfountain.com/feedback/v1/BinaryFountain-Survey-Default.jpg';
    var background = survey && survey.startSurveyPageBackground ? survey.startSurveyPageBackground : defaultBackground;
    var currentStartText = surveyStartTexts[this.props.selectedLanguage] ? surveyStartTexts[this.props.selectedLanguage] : surveyStartTexts.en;
    var surveyNameLength = survey && survey.name ? (0, _utilElement.getSurveyNameLength)(survey.name, this.props.selectedLanguage) : '';
    return _react2.default.createElement(
      _Grid2.default,
      null,
      _react2.default.createElement(
        _Row2.default,
        { style: { height: this.state.height, width: '100%', margin: '0px' }, id: 'survey_home_page' },
        _react2.default.createElement(
          _Col2.default,
          { md: 6, sm: 12, className: this.state.device_type === 'mobile' ? this.styles.survey_header_container_sm : this.styles.survey_header_container_md },
          _react2.default.createElement(
            'div',
            { className: this.styles.survey_header, style: { 'background': 'linear-gradient(134.72deg, rgba(48,35,174, 0.85), rgba(255,108,14, 0.85)), url(' + background + ')', 'backgroundRepeat': 'no-repeat', 'backgroundPosition': 'center', 'backgroundSize': 'contain' } },
            _react2.default.createElement(
              'div',
              { className: this.styles.survey_name },
              _react2.default.createElement(
                'div',
                { className: surveyNameLength > _utilConstants.SURVEY_NAME_SHORT_LENGTH ? this.styles.survey_name__long : this.styles.survey_name__short },
                _react2.default.createElement(
                  'span',
                  null,
                  (0, _utilElement.getTextForLanguage)(survey.name, this.props.selectedLanguage)
                )
              )
            ),
            _react2.default.createElement(
              _Col2.default,
              { sm: 12, xs: 12, lgHidden: true, mdHidden: true, className: this.styles.survey_description_sm },
              _react2.default.createElement(
                _Row2.default,
                { className: surveyNameLength > _utilConstants.SURVEY_NAME_SHORT_LENGTH ? this.styles.survey_description_sm_text__long : this.styles.survey_description_sm_text__short },
                _react2.default.createElement(
                  _Col2.default,
                  { className: this.styles.survey_description_text_sm + ' no_padding' },
                  _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: (0, _utilElement.getTextForLanguage)(survey.description, this.props.selectedLanguage) } })
                )
              )
            ),
            this.props.showBranding && _react2.default.createElement(
              _Row2.default,
              null,
              _react2.default.createElement(
                _Col2.default,
                { md: 12, smHidden: true, xsHidden: true },
                _react2.default.createElement(
                  'div',
                  { className: this.styles.copy_right_lg },
                  _react2.default.createElement(
                    'div',
                    { className: this.styles.powered_by },
                    'POWERED BY'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: this.styles.powered_by_name },
                    _react2.default.createElement('img', { style: { width: '200px' }, src: 'https://cdn.consumerism.pressganey.com/pgforsta.png' })
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _Col2.default,
          { md: 6, sm: 12, className: this.state.device_type === 'mobile' ? this.styles.survey_desc_container_sm : this.styles.survey_desc_container_md },
          _react2.default.createElement(
            'div',
            { className: this.styles.survey_description },
            _react2.default.createElement(
              _Row2.default,
              { style: { marginTop: '0px', textAlign: 'center' } },
              _react2.default.createElement(
                _Col2.default,
                { md: 12, mdHidden: true, lgHidden: true, className: this.styles.survey_button_sm },
                _react2.default.createElement(_mozart_ui.MozartButton, {
                  background: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : true,
                  data: currentStartText,
                  title: currentStartText,
                  onClick: this.startSurvey.bind(this),
                  color: this.props.theme && this.props.theme.customTextColor ? this.props.theme.customTextColor : '#fff',
                  style: { height: '40px', paddingTop: '5px', border: '1px solid ' + this.props.theme.colorCode }
                })
              )
            ),
            _react2.default.createElement(
              _Row2.default,
              { style: { marginTop: '0px', textAlign: 'center' }, className: 'no_margin' },
              _react2.default.createElement(
                _Col2.default,
                { md: 12, className: this.state.device_type === 'mobile' ? this.styles.client_logo_sm : this.styles.client_logo_md },
                _react2.default.createElement('img', { src: this.props.clientLogoUrl })
              )
            ),
            _react2.default.createElement(
              _Row2.default,
              { style: { maxHeight: '75%', overflow: 'auto' }, className: 'no_margin' },
              _react2.default.createElement(
                _Col2.default,
                { md: 12, smHidden: true, xsHidden: true, className: this.styles.survey_description_text + ' no_padding' },
                _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: (0, _utilElement.getTextForLanguage)(survey.description, this.props.selectedLanguage) } })
              )
            ),
            _react2.default.createElement(
              _Row2.default,
              { style: { bottom: '30px', position: 'fixed' } },
              _react2.default.createElement(
                _Col2.default,
                { md: 12, smHidden: true, xsHidden: true, className: this.styles.survey_button_lg },
                _react2.default.createElement(_mozart_ui.MozartButton, {
                  background: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : true,
                  color: this.props.theme && this.props.theme.customTextColor ? this.props.theme.customTextColor : '#fff',
                  style: { height: '40px', paddingTop: '5px', border: '1px solid ' + this.props.theme.colorCode },
                  data: currentStartText,
                  onClick: this.startSurvey.bind(this)
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          _Col2.default,
          { sm: 12, mdHidden: true, lgHidden: true, className: 'no_padding' },
          _react2.default.createElement(
            'div',
            { className: this.styles.copy_right_sm },
            _react2.default.createElement(
              'div',
              { className: this.styles.powered_by },
              'POWERED BY ',
              _react2.default.createElement(
                'b',
                null,
                _react2.default.createElement('img', { style: { width: '200px' }, src: 'https://cdn.consumerism.pressganey.com/pgforsta.png' })
              )
            )
          )
        )
      )
    );
  };

  return SurveyHome;
}(_react.Component), _class2.propTypes = {
  onStartSurvey: _react.PropTypes.func,
  getTextForLanguage: _react.PropTypes.func,
  clientLogoUrl: _react.PropTypes.string,
  survey: _react.PropTypes.object,
  params: _react.PropTypes.object,
  theme: _react.PropTypes.object,
  showBranding: _react.PropTypes.boolean,
  selectedLanguage: _react.PropTypes.string
}, _temp)) || _class);
exports.default = SurveyHome;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SurveyHome/SurveyHome.js
// module id = 2308
// module chunks = 0